document.addEventListener('click', function (e) {
    if (!e.target.closest('#btnEliminarEntregaLineaDesdEditar')) return;

    const idLinea   = document.getElementById('idLineaEntregaLineaEditar').value;
    const idReporte = document.getElementById('idReporteSopladoEditarLinea').value;

    const inputIdEliminar      = document.getElementById('idLineaEntregaLineaEliminar');
    const inputReporteEliminar = document.getElementById('idReporteSopladoEliminarLinea');

    if (inputIdEliminar)      inputIdEliminar.value      = idLinea   ?? '';
    if (inputReporteEliminar) inputReporteEliminar.value = idReporte ?? '';
});

document.addEventListener('submit', function (e) {
    const form = e.target.closest('#formEliminarEntregaLineaSoplado');
    if (!form) return;
    e.preventDefault();

    modal = form.closest('.modal');
    modalEditar = document.getElementById('modalEditarEntregaLineaSoplado');


    const btnSubmit = form.querySelector('[type="submit"]');
    if (btnSubmit) btnSubmit.disabled = true;

    const data = new FormData(form);

    fetch('/api/soplado/eliminar-entrega-linea', {
        method: 'POST',
        credentials: 'include',
        body: data
    })
    .then(r => r.json())
    .then(json => {
        const errores = json.result.errores ?? [];
        errores.forEach(e => lanzarAlerta(e.mensaje, e.clase));

        if (!json.result.hayErrores) {
            const idReporte = document.getElementById('idReporteSopladoEliminarLinea').value;
            form.reset();
            modal.classList.remove('modal--show');
            if (modalEditar) modalEditar.classList.remove('modal--show');
            
            if (idReporte && typeof window.actualizarTablaEntregaLinea === 'function') {
                window.actualizarTablaEntregaLinea(idReporte);
            }
            if (typeof window.actualizarModalReporteSoplado === 'function') {
                window.actualizarModalReporteSoplado(idReporte);
            }
            if (typeof window.actualizarBalanceSoplado === 'function') {
                window.actualizarBalanceSoplado(idReporte);
            }
            lanzarAlerta('Entrega en línea eliminada correctamente.', 'alerta-verde');
        }
    })
    .catch(() => lanzarAlerta('Error al conectar con el servidor.', 'alerta-roja'))
    .finally(() => { if (btnSubmit) btnSubmit.disabled = false; });
});
